<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-width="180px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="被投诉人名称" prop="respondentName">
            <el-input
              v-model="form.respondentName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="法定代表人姓名" prop="respondentLegalName">
            <el-input
              v-model="form.respondentLegalName"
              placeholder="请输入"
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="被投诉人联系地址" prop="respondentComplainant">
            <el-input
              v-model="form.respondentComplainant"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系人姓名" prop="respondentUserName">
            <el-input
              v-model="form.respondentUserName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系人手机号码" prop="respondentContactPhone">
            <el-input
              v-model="form.respondentContactPhone"
              placeholder="请输入"
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { checkPhone, Name } from '@/utils/rules'
export default {
  data() {
    return {
      form:
        process.env.NODE_ENV === 'production'
          ? {
              respondentName: undefined, //被投诉人名称
              respondentLegalName: undefined, //法定代表人姓名
              respondentComplainant: undefined, //被投诉人联系地址
              respondentUserName: undefined, //联系人姓名
              respondentContactPhone: undefined //联系人手机号码
            }
          : {
              respondentName: '李四', //被投诉人名称
              respondentLegalName: '李四', //法定代表人姓名
              respondentComplainant: '李四', //被投诉人联系地址
              respondentUserName: '李四', //联系人姓名
              respondentContactPhone: '13420512233' //联系人手机号码
            },
      rules: {
        respondentName: [
          { required: true, message: '请输入被投诉人名称', trigger: 'blur' },
          {
            validator: Name,
            trigger: 'change'
          }
        ],
        respondentLegalName: [
          { required: true, message: '请输入法定代表人姓名', trigger: 'blur' },
          {
            validator: Name,
            trigger: 'change'
          }
        ],
        respondentComplainant: [
          { required: true, message: '请输入被投诉人联系地址', trigger: 'blur' }
        ],
        respondentUserName: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' },
          {
            validator: Name,
            trigger: 'change'
          }
        ],
        respondentContactPhone: [
          { required: true, message: '请输入联系人手机号码', trigger: 'blur' },
          {
            validator: checkPhone,
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    // 表单校验规则
    async getBeForm() {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    }
  }
  // mounted () {
  //   console.log(this.$refs.form.$children,'this.$refs.form');
  // },
}
</script>

<style lang="scss" scoped></style>
